'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _extends2 = require('babel-runtime/helpers/extends');
var _extends3 = _interopRequireDefault(_extends2);
exports.default = computors;
var _d = require('d3');
var _d2 = _interopRequireDefault(_d);
var _ramda = require('ramda');
var R = _interopRequireWildcard(_ramda);
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function computors(target) {
  target.computors = (0, _extends3.default)({}, target.computors, {
    values: function values(data) {
      return R.pipe(target.accessors.areas, R.propOr([], 'geometries'), R.map(target.accessors.value), R.filter(R.identity))(data);
    },
    domain: function domain(options, data) {
      return R.pipe(target.computors.values, function (values) {
        return _d2.default.extent(values);
      }, function (extent) {
        var minDomainOptions = target.accessors.minDomainOptions(options);
        var maxDomainOptions = target.accessors.maxDomainOptions(options);
        return [!R.isNil(minDomainOptions) && minDomainOptions < domainValues[0] ? minDomainOptions : extent[0], !R.isNil(maxDomainOptions) && maxDomainOptions > domainValues[1] ? maxDomainOptions : extent[1]];
      })(data);
    },
    colorScale: function colorScale(options, data) {
      return _d2.default.scale.quantize().domain(target.computors.domain(options, data)).range(target.accessors.colors(options));
    }
  });
}